module.exports = __webpack_public_path__ + "img/logo-2.315955e0.png";